module.exports = __webpack_public_path__ + "img/6.948f49bf.png";